module.exports = __webpack_public_path__ + "static/media/BannerD10.f40b5084.png";